import { CSSProperties, ReactNode } from 'react';
import { StyledInfoCardContainer } from './info-card.styles';
export const InfoCard = ({
  title,
  subtitle,
  background,
  styles,
  isSmall
}: {
  title: string | ReactNode;
  subtitle: string | ReactNode;
  background: boolean;
  styles?: CSSProperties;
  isSmall?: boolean;
}) => <StyledInfoCardContainer background={background} style={styles} $isSmall={isSmall} data-sentry-element="StyledInfoCardContainer" data-sentry-component="InfoCard" data-sentry-source-file="info-card.tsx">
    {typeof title === 'string' ? <p> {title}</p> : title}
    {typeof subtitle === 'string' ? <p>{subtitle}</p> : subtitle}
  </StyledInfoCardContainer>;